// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c412488e361cb74e513591c3073f8b9278015ea8/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};